import type { CoverageEntitiesResult, RouteMetricsResult } from '../api';
import { LayerPanel, useLayerToggle } from './LayerPanel';
import { LAYERS, type LayerKey, type LayerTab } from './layers';

/**
 * Panel derecho deslizante de capas territoriales — existe en Cobertura e
 * Infraestructura vial, cada una viendo solo sus propias capas
 * (`tabFilter`) del mismo catálogo `LAYERS` compartido. Envoltorio fino
 * sobre LayerPanel (grouped): la lógica de conteo/color/toggle es 100% la
 * misma que ya usa Ficha, esto solo aporta el chrome de "cajón" colapsable.
 */
export function RightLayerDrawer({
  open,
  onToggleOpen,
  title = 'Capas territoriales',
  tabFilter,
  routeMetrics,
  coverageEntities,
  activeLayers,
  onToggleLayer,
  onShowAll,
  onHideAll,
}: {
  open: boolean;
  onToggleOpen: () => void;
  title?: string;
  tabFilter?: LayerTab;
  routeMetrics: RouteMetricsResult | null;
  coverageEntities: CoverageEntitiesResult | null;
  activeLayers: Set<LayerKey>;
  onToggleLayer: (key: LayerKey) => void;
  onShowAll: (keys?: LayerKey[]) => void;
  onHideAll: (keys?: LayerKey[]) => void;
}): JSX.Element {
  const scopedKeys = tabFilter ? LAYERS.filter(l => l.tab === tabFilter).map(l => l.key) : undefined;
  return (
    <div className={open ? 'lop-right-drawer lop-right-drawer-open' : 'lop-right-drawer'}>
      <button className="lop-right-drawer-handle" onClick={onToggleOpen} aria-label={open ? 'Ocultar capas' : 'Mostrar capas'} title={title}>
        {open ? '✕' : '▤'}
      </button>
      {open && (
        <div className="lop-right-drawer-body">
          <div className="lop-right-drawer-header">
            <p className="cov-panel-title">{title}</p>
            <div className="cov-layer-actions">
              <button onClick={() => onShowAll(scopedKeys)}>Mostrar todo</button>
              <button onClick={() => onHideAll(scopedKeys)}>Ocultar todo</button>
            </div>
          </div>
          <LayerPanel
            routeMetrics={routeMetrics}
            coverageEntities={coverageEntities}
            activeLayers={activeLayers}
            onToggle={onToggleLayer}
            grouped
            tabFilter={tabFilter}
            className="ft-layer-panel lop-right-drawer-layers"
          />
        </div>
      )}
    </div>
  );
}

export { useLayerToggle };
